import React from 'react';

export default function TermsPageUk() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Умови користування Radiomonitor.net</h1>
      <p>
        Ці Умови користування (далі – «Умови») регулюють доступ та використання сервісу Radiomonitor.net (далі – «Сервіс»).
        Користуючись Сервісом, ви підтверджуєте, що приймаєте ці Умови в повному обсязі.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. Загальні положення</h2>
      <p>Radiomonitor.net є онлайн-сервісом аналітики, моніторингу та супутніх інструментів для інтернет-радіостанцій.</p>
      <p>Доступ до Сервісу надається після ознайомлення з цими Умовами та їх прийняття.</p>
      <p>Адміністрація має право змінювати Умови, оновлення публікуються на сайті та набирають чинності з моменту розміщення.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. Надання послуг</h2>
      <p>Послуги Сервісу надаються на умовах передплати згідно з обраним тарифним планом чи індивідуальною угодою.</p>
      <p>Дані та звіти, сформовані Сервісом, мають довідковий характер і використовуються на власний розсуд користувача.</p>
      <p>Radiomonitor.net не відповідає за зовнішні фактори (перебої провайдерів, сторонні сервіси тощо), які впливають на роботу радіостанції.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Обмеження відповідальності</h2>
      <p>Ми докладаємо всіх зусиль для стабільної роботи, але не гарантуємо безперервність чи відсутність технічних помилок.</p>
      <p>Сервіс не несе відповідальності за втрати, пов’язані з використанням або неможливістю використання інструментів Radiomonitor.net.</p>
      <p>Користувач самостійно відповідає за налаштування свого обладнання, програмних засобів та інтернет-з’єднання.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Оплата та підписка</h2>
      <p>Платний функціонал активується після успішної оплати відповідного тарифу чи пакету послуг.</p>
      <p>Оплата здійснюється через доступні платіжні сервіси, у тому числі через автоматичне списання (якщо активовано).</p>
      <p>При відмові від Сервісу сплачені кошти за вже активований період не повертаються, якщо інше не передбачено договором.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Інтелектуальна власність</h2>
      <p>Контент, програмний код, бази даних та дизайн Сервісу є власністю Radiomonitor.net або ліцензіарів.</p>
      <p>Забороняється копіювати чи поширювати матеріали, алгоритми й статистичні дані без письмового дозволу власника.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Конфіденційність</h2>
      <p>Сервіс збирає мінімальний обсяг технічних даних (IP-адреса, параметри підключення, статистика використання) для підтримки роботи.</p>
      <p>Персональні дані не передаються третім особам, окрім випадків, прямо визначених законодавством.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. Зберігання даних користувачів</h2>
      <p>У разі припинення оплати послуг дані користувача зберігаються 30 календарних днів з моменту завершення підписки.</p>
      <p>Після закінчення зазначеного строку інформація може бути видалена без можливості подальшого відновлення.</p>
      <p>Для користувачів з безперервною передплатою понад один рік гарантується зберігання даних щонайменше протягом року.</p>
      <p>За письмовим зверненням та додатковою оплатою строк зберігання може бути подовжений; умови узгоджуються з підтримкою.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Припинення доступу</h2>
      <p>Radiomonitor.net може призупинити або обмежити доступ користувача у випадку порушення Умов чи вимог законодавства.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Контакти</h2>
      <p>
        З питаннями та пропозиціями звертайтесь до адміністрації Сервісу:
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
